import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../@commons/ui-components/shared.module';
import { ArticleComponent } from "../../@commons/@components/article/article.component";
import { TaskApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/task/task-api';
import {
  TaskListRequest
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/requests/location/task-list.request';
import { StorageService } from '../../@commons/@services/front/storage.service';
import {
  TaskListResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/task-list.response';
import { ArticleListRequest } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/requests/article/article-list.request';
import { ArticleApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/article/article-api';

@Component({
    selector: 'vw-agenda-archives', // Indicates this is a standalone component
    imports: [CommonModule, SharedModule, TranslateModule, ArticleComponent], // Modules required by this component
    templateUrl: './agenda-archives.component.html', // HTML template for the component
    styleUrl: './agenda-archives.component.scss', // Stylesheet for the component
    providers: [{
            provide: TaskApi,
            useClass: TaskApi
        }, {
            provide: ArticleApi,
            useClass: ArticleApi
        }]
})
export class AgendaArchivesComponent implements OnInit {

  /**
   * List of archived tasks.
   * @type {TaskListResponse[]}
   */
  tasks: TaskListResponse[] = [];
  currentTaskPage: number = 0;
  taskPageSize: number = 20;
  articles: any[] = [];
  isLoading: boolean = false;
  /**
   * List of advices related to the agenda.
   * @type {any[]}
   */
  advices: any[] = [];

  /**
   * Initializes the AgendaArchivesComponent with required services.
   * @param {TaskApi} taskApi - Service to fetch agenda-related data
   * @param storageService
   */
  constructor(private taskApi: TaskApi,
    private storageService: StorageService,
    private articleApi: ArticleApi) { }

  /**
   * Lifecycle hook that is called after data-bound properties are initialized.
   * Subscribes to tasks and advices data from AgendaService.
   */
  async ngOnInit() {
    this.isLoading = true;
    const taskFilters: TaskListRequest = new TaskListRequest();
    this.currentTaskPage = 0;
    await this.loadTasks();
    await this.loadArticles();
    this.isLoading = false;
  }

  async loadTasks() {
    const taskFilters: TaskListRequest = new TaskListRequest();
    const response = await this.taskApi.list(taskFilters, this.currentTaskPage, this.taskPageSize, this.storageService.getCurrentLanguage());
    this.tasks.push(...response.results);
  }

  async loadMoreTasks() {
    this.currentTaskPage++;
    await this.loadTasks();
  }

  async loadArticles() {
    const articles = await this.articleApi.list(new ArticleListRequest(), 1, 20, this.storageService.getCurrentLanguage());
    this.articles = articles.results;
  }
}
